import React from 'react';

import { flagStyles } from '../settings';

const SvgHU = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-2352px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgHU;
